/** CSS transform preview for per-clip motion presets (matches export motion). */

import { resolveClipMotionPreviewStyle } from '@/lib/songAudioMotion';
import { clampEditorAnimationSpeed } from '@/lib/editorAnimationSettings';
import { motionProgressWithSpeed } from '@/lib/motionProgress';
import { motionPreviewStyleFromPreset } from '@/lib/videoMotionPresets';

export function motionPreviewStyle(preset, strength, progress) {
  return motionPreviewStyleFromPreset(preset, progress, strength);
}

export function clipMotionProgress(clip, timelineTime) {
  const t = Math.max(0, Number(timelineTime) - (Number(clip?.startTime) || 0));
  const d = Math.max(0.05, Number(clip?.playbackDuration || clip?.duration) || 5);
  return Math.max(0, t / d);
}

/** Motion style for a clip — audio-driven when timeline present, else preset Ken Burns. */
export function clipMotionPreviewStyle(clip, timelineTime, motionOpts = {}) {
  const audioStyle = resolveClipMotionPreviewStyle(clip, timelineTime, motionOpts);
  if (audioStyle) return audioStyle;
  if (motionOpts.defaultAnimationEnabled === false) {
    return {};
  }
  const presetSpeed = clampEditorAnimationSpeed(motionOpts.presetAnimationSpeed ?? 1);
  const tOver = clipMotionProgress(clip, timelineTime);
  const progress = motionProgressWithSpeed(tOver, presetSpeed);
  const baseStrength = Number(clip?.motionStrength) || 0.12;
  const strength = Math.min(0.45, baseStrength * (1 + presetSpeed * 0.08));
  return motionPreviewStyle(
    clip?.motionPreset,
    strength,
    progress,
  );
}

export { motionProgressWithSpeed };
